export default __webpack_public_path__ + "media/images/images/pages/signature-scan-db80eb7b198bf316dba7a61509ced1d4.png";